export default __webpack_public_path__ + "static/media/out.e3ad2199.svg";